app.controller('analysisController', function ($scope, $rootScope, $routeParams, $window, $sce, safeApply, systemService, analysisService) {

  const route_params = $routeParams
  console.log('route_params :>> ', route_params);

  $scope.route                            = 'analysis'
  $scope.content_cards                    = []
  $scope.explainer_video_analysis_playing = false
  
  $scope.analysisRunning = false
  
  $rootScope.step_tracker = 2

  $scope.ranger = 4

  initController()

  // $scope.chart_1 = 'https://api.mapbox.com/styles/v1/mapbox/light-v10/static/[-96.699,32.85152,-96.6879,32.85524]/500x281?attribution=false&logo=false&before_layer=road-label&addlayer=%7B%22id%22%3A%22streets%22%2C%22type%22%3A%22circle%22%2C%22paint%22%3A%7B%22circle-radius%22%3A5%2C%22circle-color%22%3A%5B%22match%22%2C%5B%22get%22%2C%22type%22%5D%2C%22comp%22%2C%22limegreen%22%2C%22subject%22%2C%22blue%22%2C%22%23ccc%22%5D%7D%2C%22source%22%3A%7B%22type%22%3A%22geojson%22%2C%22url%22%3A%22mapbox%3A%2F%2Fmapbox.mapbox-streets-v7%22%2C%22data%22%3A%7B%22type%22%3A%22FeatureCollection%22%2C%22features%22%3A%5B%7B%22type%22%3A%22Feature%22%2C%22geometry%22%3A%7B%22type%22%3A%22Point%22%2C%22coordinates%22%3A%5B-96.6906%2C32.85283%5D%7D%2C%22properties%22%3A%7B%22type%22%3A%22comp%22%7D%7D%2C%7B%22type%22%3A%22Feature%22%2C%22geometry%22%3A%7B%22type%22%3A%22Point%22%2C%22coordinates%22%3A%5B-96.6939%2C32.85152%5D%7D%2C%22properties%22%3A%7B%22type%22%3A%22comp%22%7D%7D%2C%7B%22type%22%3A%22Feature%22%2C%22geometry%22%3A%7B%22type%22%3A%22Point%22%2C%22coordinates%22%3A%5B-96.6922%2C32.85268%5D%7D%2C%22properties%22%3A%7B%22type%22%3A%22comp%22%7D%7D%2C%7B%22type%22%3A%22Feature%22%2C%22geometry%22%3A%7B%22type%22%3A%22Point%22%2C%22coordinates%22%3A%5B-96.6941%2C32.85199%5D%7D%2C%22properties%22%3A%7B%22type%22%3A%22comp%22%7D%7D%2C%7B%22type%22%3A%22Feature%22%2C%22geometry%22%3A%7B%22type%22%3A%22Point%22%2C%22coordinates%22%3A%5B-96.6952%2C32.85197%5D%7D%2C%22properties%22%3A%7B%22type%22%3A%22comp%22%7D%7D%2C%7B%22type%22%3A%22Feature%22%2C%22geometry%22%3A%7B%22type%22%3A%22Point%22%2C%22coordinates%22%3A%5B-96.6987%2C32.85273%5D%7D%2C%22properties%22%3A%7B%22type%22%3A%22comp%22%7D%7D%2C%7B%22type%22%3A%22Feature%22%2C%22geometry%22%3A%7B%22type%22%3A%22Point%22%2C%22coordinates%22%3A%5B-96.6947%2C32.85239%5D%7D%2C%22properties%22%3A%7B%22type%22%3A%22comp%22%7D%7D%2C%7B%22type%22%3A%22Feature%22%2C%22geometry%22%3A%7B%22type%22%3A%22Point%22%2C%22coordinates%22%3A%5B-96.6899%2C32.85524%5D%7D%2C%22properties%22%3A%7B%22type%22%3A%22comp%22%7D%7D%2C%7B%22type%22%3A%22Feature%22%2C%22geometry%22%3A%7B%22type%22%3A%22Point%22%2C%22coordinates%22%3A%5B-96.6981%2C32.85286%5D%7D%2C%22properties%22%3A%7B%22type%22%3A%22comp%22%7D%7D%2C%7B%22type%22%3A%22Feature%22%2C%22geometry%22%3A%7B%22type%22%3A%22Point%22%2C%22coordinates%22%3A%5B-96.699%2C32.85272%5D%7D%2C%22properties%22%3A%7B%22type%22%3A%22comp%22%7D%7D%2C%7B%22type%22%3A%22Feature%22%2C%22geometry%22%3A%7B%22type%22%3A%22Point%22%2C%22coordinates%22%3A%5B-96.6929%2C32.8533%5D%7D%2C%22properties%22%3A%7B%22type%22%3A%22comp%22%7D%7D%2C%7B%22type%22%3A%22Feature%22%2C%22geometry%22%3A%7B%22type%22%3A%22Point%22%2C%22coordinates%22%3A%5B-96.6975%2C32.85389%5D%7D%2C%22properties%22%3A%7B%22type%22%3A%22comp%22%7D%7D%2C%7B%22type%22%3A%22Feature%22%2C%22geometry%22%3A%7B%22type%22%3A%22Point%22%2C%22coordinates%22%3A%5B-96.6879%2C32.85305%5D%7D%2C%22properties%22%3A%7B%22type%22%3A%22comp%22%7D%7D%2C%7B%22type%22%3A%22Feature%22%2C%22geometry%22%3A%7B%22type%22%3A%22Point%22%2C%22coordinates%22%3A%5B-96.6917%2C32.85298%5D%7D%2C%22properties%22%3A%7B%22type%22%3A%22comp%22%7D%7D%2C%7B%22type%22%3A%22Feature%22%2C%22geometry%22%3A%7B%22type%22%3A%22Point%22%2C%22coordinates%22%3A%5B-96.6914%2C32.85332%5D%7D%2C%22properties%22%3A%7B%22type%22%3A%22comp%22%7D%7D%2C%7B%22type%22%3A%22Feature%22%2C%22geometry%22%3A%7B%22type%22%3A%22Point%22%2C%22coordinates%22%3A%5B-96.6919%2C32.85345%5D%7D%2C%22properties%22%3A%7B%22type%22%3A%22comp%22%7D%7D%2C%7B%22type%22%3A%22Feature%22%2C%22geometry%22%3A%7B%22type%22%3A%22Point%22%2C%22coordinates%22%3A%5B-96.6977%2C32.85293%5D%7D%2C%22properties%22%3A%7B%22type%22%3A%22comp%22%7D%7D%2C%7B%22type%22%3A%22Feature%22%2C%22geometry%22%3A%7B%22type%22%3A%22Point%22%2C%22coordinates%22%3A%5B-96.6898%2C32.85366%5D%7D%2C%22properties%22%3A%7B%22type%22%3A%22comp%22%7D%7D%2C%7B%22type%22%3A%22Feature%22%2C%22geometry%22%3A%7B%22type%22%3A%22Point%22%2C%22coordinates%22%3A%5B-96.693%2C32.85184%5D%7D%2C%22properties%22%3A%7B%22type%22%3A%22comp%22%7D%7D%2C%7B%22type%22%3A%22Feature%22%2C%22geometry%22%3A%7B%22type%22%3A%22Point%22%2C%22coordinates%22%3A%5B-96.6949%2C32.85287%5D%7D%2C%22properties%22%3A%7B%22type%22%3A%22comp%22%7D%7D%2C%7B%22type%22%3A%22Feature%22%2C%22geometry%22%3A%7B%22type%22%3A%22Point%22%2C%22coordinates%22%3A%5B-96.6978%2C32.85326%5D%7D%2C%22properties%22%3A%7B%22type%22%3A%22comp%22%7D%7D%2C%7B%22type%22%3A%22Feature%22%2C%22geometry%22%3A%7B%22type%22%3A%22Point%22%2C%22coordinates%22%3A%5B-96.6951%2C32.85334%5D%7D%2C%22properties%22%3A%7B%22type%22%3A%22comp%22%7D%7D%2C%7B%22type%22%3A%22Feature%22%2C%22geometry%22%3A%7B%22type%22%3A%22Point%22%2C%22coordinates%22%3A%5B-96.6974%2C32.85228%5D%7D%2C%22properties%22%3A%7B%22type%22%3A%22comp%22%7D%7D%2C%7B%22type%22%3A%22Feature%22%2C%22geometry%22%3A%7B%22type%22%3A%22Point%22%2C%22coordinates%22%3A%5B-96.6972%2C32.85322%5D%7D%2C%22properties%22%3A%7B%22type%22%3A%22comp%22%7D%7D%2C%7B%22type%22%3A%22Feature%22%2C%22geometry%22%3A%7B%22type%22%3A%22Point%22%2C%22coordinates%22%3A%5B-96.697%2C32.85272%5D%7D%2C%22properties%22%3A%7B%22type%22%3A%22comp%22%7D%7D%2C%7B%22type%22%3A%22Feature%22%2C%22geometry%22%3A%7B%22type%22%3A%22Point%22%2C%22coordinates%22%3A%5B-96.6934%2C32.85295%5D%7D%2C%22properties%22%3A%7B%22type%22%3A%22subject%22%2C%22name%22%3A%22S%22%7D%7D%5D%7D%7D%7D&padding=25&access_token=pk.eyJ1IjoiZ2xlbm5nIiwiYSI6ImNpZmZ1ZnZqbjh5eGJzdWtua3Zib3M0c2gifQ.TcurCtii8i7e3w7oo1WW5Q'
  $scope.chart_1 = 'https://storage.cloud.google.com/analysis_assets/charts/test2.svg'
  
  const video = document.getElementById('explainer_video_analysis')

  $('#videoPlayer').on('hidden.bs.modal', function () {
    $('#videoPlayer iframe').removeAttr('src');
  })
  $('#videoPlayer').on('show.bs.modal', function () {
    $('#videoPlayer iframe').attr('src', 'https://player.vimeo.com/video/326321705?autoplay=1&loop=1&autopause=0');
  })
  video.addEventListener("playing", function () {
    $scope.explainer_video_analysis_playing = true
    video.setAttribute('controls', 'controls')
    safeApply($scope)
  })
  video.addEventListener("pause", function () {
    $scope.explainer_video_analysis_playing = false
    video.removeAttribute('controls')
    safeApply($scope)
  })
  $scope.play_explainer_video_analysis = () => {     
    video.play()
  }
  
  $scope.routing = (route) => { 
    console.log('route :>> ', route);
    switch (route) {
      case 'signup':
        const uid        = route_params.uid;
        register_route   = `https://dashboard.propertytax.io/signup/${uid.substring(0, 3)}/${uid.substring(3)}`
        $window.location = register_route
        break
      case 'signin':
        $window.location = `https://dashboard.propertytax.io/signin/`
        break
      }
      safeApply($scope)
  }

  async function initController() {    
    if (route_params.uid == null || route_params.uid == undefined) { systemService.route_change('/') }
    
    // let functionMap = {
    //   'mapOfRecentSales'        : mapOfRecentSales,
    //   'scatterPlotOfRecentSales': scatterPlotOfRecentSales
    // }
    
    // $scope.routeToRegistration = () => {
    //   window.location.replace($scope.register_route)
    //   safeApply($scope)
    // }

    // let analysisResults = await systemService.functionCall({type: 'miniAnalysis',  uid: $scope.uid })
    // if (analysisResults.data.success) {
    //   // set title and footer (if available) to safe HTML strings for binding
    //   // Store content card info into scoped variable - content_cards
    //   $scope.content_cards = analysisResults.data.data.content_cards
    //   let analysis_data    = analysisResults.data.data.data
    //   $scope.address       = analysis_data.subj.address
    //   safeApply($scope)
    //   $scope.content_cards.map((item,index) => {
    //     item.title                                      = $sce.trustAsHtml(item.title)
    //     let functionToCall                              = functionMap[item.functionToCall];
    //     let divId                                       = `slide_${index}`
    //     if (item.hasOwnProperty('footer')) item.footer = $sce.trustAsHtml(item.footer)
    //     setTimeout(() => {
    //       functionToCall(analysis_data.subj, analysis_data.comps,divId)
    //     }, 0)
    //   })      
    // } else {
    //   console.log("Error in API call (miniAnalysis)", analysisResults.data.error);
    // }
    // $scope.analysisRunning = false
    
    $scope.analysis = {
      "situs"                         : "11705 FARRAR ST, DALLAS TX  75218-1829",
      "cad_code"                      : "057",
      "cad_account"                   : "00000381544000000",
      "owner_name"                    : "GOODRICH GLENN & SUSAN",
      "county_name"                   : "Dallas",
      "market_value"                  : 470610,
      "assessed_value"                : 376200,
      "recent_sales_map"              : "https://api.mapbox.com/styles/v1/mapbox/light-v10/static/[-96.699,32.85152,-96.6879,32.85524]/500x281?attribution=false&logo=false&before_layer=road-label&addlayer=%7B%22id%22%3A%22streets%22%2C%22type%22%3A%22circle%22%2C%22paint%22%3A%7B%22circle-radius%22%3A5%2C%22circle-color%22%3A%5B%22match%22%2C%5B%22get%22%2C%22type%22%5D%2C%22comp%22%2C%22limegreen%22%2C%22subject%22%2C%22blue%22%2C%22%23ccc%22%5D%7D%2C%22source%22%3A%7B%22type%22%3A%22geojson%22%2C%22url%22%3A%22mapbox%3A%2F%2Fmapbox.mapbox-streets-v7%22%2C%22data%22%3A%7B%22type%22%3A%22FeatureCollection%22%2C%22features%22%3A%5B%7B%22type%22%3A%22Feature%22%2C%22geometry%22%3A%7B%22type%22%3A%22Point%22%2C%22coordinates%22%3A%5B-96.6906%2C32.85283%5D%7D%2C%22properties%22%3A%7B%22type%22%3A%22comp%22%7D%7D%2C%7B%22type%22%3A%22Feature%22%2C%22geometry%22%3A%7B%22type%22%3A%22Point%22%2C%22coordinates%22%3A%5B-96.6939%2C32.85152%5D%7D%2C%22properties%22%3A%7B%22type%22%3A%22comp%22%7D%7D%2C%7B%22type%22%3A%22Feature%22%2C%22geometry%22%3A%7B%22type%22%3A%22Point%22%2C%22coordinates%22%3A%5B-96.6922%2C32.85268%5D%7D%2C%22properties%22%3A%7B%22type%22%3A%22comp%22%7D%7D%2C%7B%22type%22%3A%22Feature%22%2C%22geometry%22%3A%7B%22type%22%3A%22Point%22%2C%22coordinates%22%3A%5B-96.6941%2C32.85199%5D%7D%2C%22properties%22%3A%7B%22type%22%3A%22comp%22%7D%7D%2C%7B%22type%22%3A%22Feature%22%2C%22geometry%22%3A%7B%22type%22%3A%22Point%22%2C%22coordinates%22%3A%5B-96.6952%2C32.85197%5D%7D%2C%22properties%22%3A%7B%22type%22%3A%22comp%22%7D%7D%2C%7B%22type%22%3A%22Feature%22%2C%22geometry%22%3A%7B%22type%22%3A%22Point%22%2C%22coordinates%22%3A%5B-96.6987%2C32.85273%5D%7D%2C%22properties%22%3A%7B%22type%22%3A%22comp%22%7D%7D%2C%7B%22type%22%3A%22Feature%22%2C%22geometry%22%3A%7B%22type%22%3A%22Point%22%2C%22coordinates%22%3A%5B-96.6947%2C32.85239%5D%7D%2C%22properties%22%3A%7B%22type%22%3A%22comp%22%7D%7D%2C%7B%22type%22%3A%22Feature%22%2C%22geometry%22%3A%7B%22type%22%3A%22Point%22%2C%22coordinates%22%3A%5B-96.6899%2C32.85524%5D%7D%2C%22properties%22%3A%7B%22type%22%3A%22comp%22%7D%7D%2C%7B%22type%22%3A%22Feature%22%2C%22geometry%22%3A%7B%22type%22%3A%22Point%22%2C%22coordinates%22%3A%5B-96.6981%2C32.85286%5D%7D%2C%22properties%22%3A%7B%22type%22%3A%22comp%22%7D%7D%2C%7B%22type%22%3A%22Feature%22%2C%22geometry%22%3A%7B%22type%22%3A%22Point%22%2C%22coordinates%22%3A%5B-96.699%2C32.85272%5D%7D%2C%22properties%22%3A%7B%22type%22%3A%22comp%22%7D%7D%2C%7B%22type%22%3A%22Feature%22%2C%22geometry%22%3A%7B%22type%22%3A%22Point%22%2C%22coordinates%22%3A%5B-96.6929%2C32.8533%5D%7D%2C%22properties%22%3A%7B%22type%22%3A%22comp%22%7D%7D%2C%7B%22type%22%3A%22Feature%22%2C%22geometry%22%3A%7B%22type%22%3A%22Point%22%2C%22coordinates%22%3A%5B-96.6975%2C32.85389%5D%7D%2C%22properties%22%3A%7B%22type%22%3A%22comp%22%7D%7D%2C%7B%22type%22%3A%22Feature%22%2C%22geometry%22%3A%7B%22type%22%3A%22Point%22%2C%22coordinates%22%3A%5B-96.6879%2C32.85305%5D%7D%2C%22properties%22%3A%7B%22type%22%3A%22comp%22%7D%7D%2C%7B%22type%22%3A%22Feature%22%2C%22geometry%22%3A%7B%22type%22%3A%22Point%22%2C%22coordinates%22%3A%5B-96.6917%2C32.85298%5D%7D%2C%22properties%22%3A%7B%22type%22%3A%22comp%22%7D%7D%2C%7B%22type%22%3A%22Feature%22%2C%22geometry%22%3A%7B%22type%22%3A%22Point%22%2C%22coordinates%22%3A%5B-96.6914%2C32.85332%5D%7D%2C%22properties%22%3A%7B%22type%22%3A%22comp%22%7D%7D%2C%7B%22type%22%3A%22Feature%22%2C%22geometry%22%3A%7B%22type%22%3A%22Point%22%2C%22coordinates%22%3A%5B-96.6919%2C32.85345%5D%7D%2C%22properties%22%3A%7B%22type%22%3A%22comp%22%7D%7D%2C%7B%22type%22%3A%22Feature%22%2C%22geometry%22%3A%7B%22type%22%3A%22Point%22%2C%22coordinates%22%3A%5B-96.6977%2C32.85293%5D%7D%2C%22properties%22%3A%7B%22type%22%3A%22comp%22%7D%7D%2C%7B%22type%22%3A%22Feature%22%2C%22geometry%22%3A%7B%22type%22%3A%22Point%22%2C%22coordinates%22%3A%5B-96.6898%2C32.85366%5D%7D%2C%22properties%22%3A%7B%22type%22%3A%22comp%22%7D%7D%2C%7B%22type%22%3A%22Feature%22%2C%22geometry%22%3A%7B%22type%22%3A%22Point%22%2C%22coordinates%22%3A%5B-96.693%2C32.85184%5D%7D%2C%22properties%22%3A%7B%22type%22%3A%22comp%22%7D%7D%2C%7B%22type%22%3A%22Feature%22%2C%22geometry%22%3A%7B%22type%22%3A%22Point%22%2C%22coordinates%22%3A%5B-96.6949%2C32.85287%5D%7D%2C%22properties%22%3A%7B%22type%22%3A%22comp%22%7D%7D%2C%7B%22type%22%3A%22Feature%22%2C%22geometry%22%3A%7B%22type%22%3A%22Point%22%2C%22coordinates%22%3A%5B-96.6978%2C32.85326%5D%7D%2C%22properties%22%3A%7B%22type%22%3A%22comp%22%7D%7D%2C%7B%22type%22%3A%22Feature%22%2C%22geometry%22%3A%7B%22type%22%3A%22Point%22%2C%22coordinates%22%3A%5B-96.6951%2C32.85334%5D%7D%2C%22properties%22%3A%7B%22type%22%3A%22comp%22%7D%7D%2C%7B%22type%22%3A%22Feature%22%2C%22geometry%22%3A%7B%22type%22%3A%22Point%22%2C%22coordinates%22%3A%5B-96.6974%2C32.85228%5D%7D%2C%22properties%22%3A%7B%22type%22%3A%22comp%22%7D%7D%2C%7B%22type%22%3A%22Feature%22%2C%22geometry%22%3A%7B%22type%22%3A%22Point%22%2C%22coordinates%22%3A%5B-96.6972%2C32.85322%5D%7D%2C%22properties%22%3A%7B%22type%22%3A%22comp%22%7D%7D%2C%7B%22type%22%3A%22Feature%22%2C%22geometry%22%3A%7B%22type%22%3A%22Point%22%2C%22coordinates%22%3A%5B-96.697%2C32.85272%5D%7D%2C%22properties%22%3A%7B%22type%22%3A%22comp%22%7D%7D%2C%7B%22type%22%3A%22Feature%22%2C%22geometry%22%3A%7B%22type%22%3A%22Point%22%2C%22coordinates%22%3A%5B-96.6934%2C32.85295%5D%7D%2C%22properties%22%3A%7B%22type%22%3A%22subject%22%2C%22name%22%3A%22S%22%7D%7D%5D%7D%7D%7D&padding=25&access_token=pk.eyJ1IjoiZ2xlbm5nIiwiYSI6ImNpZmZ1ZnZqbjh5eGJzdWtua3Zib3M0c2gifQ.TcurCtii8i7e3w7oo1WW5Q",
      "recent_sales_summary"          : "There were <strong>25 sales</strong> in your neighborhood this past year that range price from $350,000 - $500,000. Our free analysis discusses which sales are the most useful to reduce your value.",
      "tax_rate"                      : "2.485281",
      "tax_amount"                    : 7449.99,
      "potential_tax_savings_scenario": 1,
      "potential_tax_savings"         : 500,
      "potential_tax_savings_text"    : "We believe there is an opportunity to reduce your tax bill!",
      "fee"                           : {
        "cap" : 250,
        "rate": 35
      },
      "already_signed_up": false,
      chart: "https://storage.googleapis.com/analysis_assets/charts/test20.svg"
    }

    // let chart1 = document.getElementById('chart1')
    // chart1.attr('src', $scope.analysis.chart1)

    let fee                             = $scope.analysis.potential_tax_savings * ($scope.analysis.fee.rate / 100)
        $scope.analysis.fee.amount      = fee > $scope.analysis.fee.cap ? ($scope.analysis.fee.cap * -1) : (fee * -1)
        $scope.analysis.fee.net_savings = $scope.analysis.potential_tax_savings - fee
    
    if ($scope.analysis.fee.rate == 35) {
      $scope.analysis.cap_fee_message = `        
        <p style="line-height: 1.3;">The success fee is a percentage of the tax savings we are able to achieve for you.</p>
        <p style="line-height: 1.3;">The success fee is capped at $${$scope.analysis.fee.cap} for this property, which means that even if 35% of the tax savings is more than the capped fee of $${$scope.analysis.fee.cap}, we only charge $${$scope.analysis.fee.cap}.</p>`      
    } else {
      $scope.analysis.cap_fee_message = `
        <p style="line-height: 1.3;">The success fee is a percentage of the tax savings we are able to achieve for you.</p>
        <p style="line-height: 1.3;">Since this property is valued at over $1,000,000, our fee for this property is 40% of the tax savings.</p>`
    }
    
    setTimeout(() => {
      initComponents()
    }, 0)
    
    safeApply($scope)
  }

  function mapOfRecentSales(subj,comps,divId) {
    try{
      const subjColor     = '#702283';
      const circleColors  = ['#dc143c','#008000','#22559c'];
      const circleOpacity = .4;
      let   compSets      = comps
        .reduce((acc,curr)=>{
            let soldYr = new Date(curr.date).getFullYear();
            acc[soldYr] == undefined && (acc[soldYr]= []);
            acc[soldYr].push(curr);
            return acc;
        },{})
      compSets = Object.values(compSets);
      console.log('mapOfRecentSales called.')
      mapboxgl.accessToken = 'pk.eyJ1IjoiZ2xlbm5nIiwiYSI6ImNpZmZ1ZnZqbjh5eGJzdWtua3Zib3M0c2gifQ.TcurCtii8i7e3w7oo1WW5Q';
      let map = new mapboxgl.Map({
        container  : divId,                                  // container id
        style      : 'mapbox://styles/mapbox/streets-v11',   // style URL
        center     : [subj.longitude, subj.latitude],        // starting position [lng, lat]
        zoom       : 10,                                     // starting zoom,
        interactive: false
      });
      let mapBounds = [];
      mapBounds.push({longitude: subj.longitude, latitude: subj.latitude});
      let layerSources = [];
      compSets.forEach(compSet=>{
          let compGeoJson = {
              type: 'geojson',
              data: {
                  type: 'FeatureCollection',
                  features: []
              }
          };
          compSet.forEach(comp=>{
              mapBounds.push({longitude: comp.longitude, latitude: comp.latitude});
              compGeoJson.data.features.push({
                  type: 'Feature',
                  geometry: {
                      type: 'Point',
                      coordinates: [comp.longitude,comp.latitude]
                  }
              })
          });
          layerSources.push(compGeoJson);
      });
      map.on('load', () => {
        let bounds = new mapboxgl.LngLatBounds();
        mapBounds.map(prop=>{
            bounds.extend([prop.longitude,prop.latitude])
        })
        layerSources.forEach((compGeoJson,index)=>{
          let circleColor = circleColors[index]
          map.addLayer({
              id: `comps${index}`,
              type: 'circle',
              paint: {
                  'circle-radius': 5,
                  'circle-color': circleColor,
                  'circle-opacity': circleOpacity
              },
              source: compGeoJson
          })
      }) 
        new mapboxgl.Marker({color: subjColor})
          .setLngLat([subj.longitude,subj.latitude])
          .addTo(map);
        map.fitBounds(bounds,{
          padding: 50
        });
      })
    } catch(error){
      console.log(error)
    }
  }

  function scatterPlotOfRecentSales(subj,comps,divId) {
    // Get width of slide to set width/height, margins and offsets
    const div    = document.getElementById(divId)
    let   width  = div.offsetWidth
    let   height = div.offsetHeight
    
    var margin      = ({left: 55, right: 10, top: 16, bottom: 55});
    var innerWidth  = width  - ( margin.left + margin.right )
    var innerHeight = height - ( margin.top + margin.bottom )
    let xOffset     = 0;
    let yOffset     = 0;

    const taxYear        = 2021;
    const xLabel         = 'Time (MM-YY)';
    const yLabel         = 'Sale Price / SQFT';
    let   xAxisTickBegin = new Date(taxYear-2,12,01);
    let   xAxisTickEnd   = new Date(taxYear+1,04,01);

    const circleColors  = ['#dc143c','#008000','#22559c'];
    const circleOpacity = .3;

    let polyRegressionStroke      = 'black';
    let polyRegressionStrokeWidth = '5px';
    
    const xValue = d => new Date(d.date);
    const yValue = d => d.sale_price_per_sqft;

    d3.select(`#${divId}`)
      .classed('svg-container', true)

    let svg = d3.select(`#${divId}`)
      .append("svg")
      .attr("preserveAspectRatio", "xMinYMid meet")
      // .attr("viewBox", `0 0 ${innerWidth + margin.left + margin.right} ${innerHeight + margin.top + margin.bottom}`)
      .attr("viewBox", `0 0 ${innerWidth + margin.left + margin.right} ${innerHeight + margin.top + margin.bottom}`)
      .classed('svg-container', true)
    
      // .attr("width", innerWidth + margin.left + margin.right)
      // .attr("height", innerHeight + margin.top + margin.bottom)
      
    // .attr("preserveAspectRatio", "xMinYMid meet")
    // .attr("viewBox", `0 0 ${innerWidth + margin.left + margin.right} ${innerHeight + margin.top + margin.bottom}`)    
    // let chart = $(`svg`)
    // aspect    = chart.width() / chart.height(),
    // container = chart.parent();
    // $(window).on("resize", function() {
    //   var targetWidth = container.width() + margin.left + margin.right;
    //   var targetheight = container.height() + margin.top + margin.bottom;

    //   chart.attr("width", targetWidth);
    //   chart.attr("height", innerHeight + margin.top + margin.bottom);
    // }).trigger("resize");
      
    // var aspect = (width / height)    
    // d3.select(window).on("resize", function () {
    //   var targetWidth = svg.node().getBoundingClientRect().width;
    //   svg.attr("width", targetWidth);
    //   svg.attr("height", targetWidth / aspect);
    // });
  
    const g = svg.append("g")
        .attr("transform", `translate(${margin.left}, ${margin.top})`);

    const xAxisG = g.append('g')
        .attr('transform', `translate(0, ${innerHeight})`);
    const yAxisG = g.append('g');

    xAxisG.append('text')
        .attr('class', 'axis-label')
        .attr('id','x-axis')
        .attr('x', innerWidth / 2)
        .attr('y', 40)
        .style('font-size','8pt')
        .style('fill', '#635F5D')
        .style('font-family', 'sans-serif')
        .text(xLabel);

    yAxisG.append('text')
        .attr('class', 'axis-label')
        .attr('x', -innerHeight / 2)
        .attr('y', -40)
        .attr('transform', `rotate(-90)`)
        .style('text-anchor', 'middle')
        .style('font-size','8pt')
        .style('fill', '#635F5D')
        .style('font-family', 'sans-serif')
        .text(yLabel);

    const xScale = d3.scaleTime();
    const yScale = d3.scaleLinear();

    let xRange = d3.extent(comps,xValue);
    xRange[0] = addDays(xRange[0], - xOffset);
    xRange[1] = addDays(xRange[1], + xOffset);
    xScale
        .domain(xRange)
        .range([0, innerWidth])
        .nice();

    const xAxis = d3.axisBottom()
        .scale(xScale)
        .tickValues(d3.timeMonths(xAxisTickBegin,xAxisTickEnd,3))
        .tickPadding(15)
        .tickSize(-innerHeight)
        .tickFormat(d3.timeFormat("%m-%y"))

    let yRange = d3.extent(comps,yValue);
    yRange[0] = yRange[0] * (1 - yOffset);
    yRange[1] = yRange[1] * (1 + yOffset);
    // yRange = [3,7]
    yScale
        .domain(yRange)
        .range([innerHeight, 0])
        .nice();

    const yAxis = d3.axisLeft()
        .scale(yScale)
        .ticks(10)
        .tickPadding(10)
        .tickSize(-innerWidth)
        .tickFormat((d)=>`$${d3.format(",")(d)}`);
    
    xAxisG
        .call(xAxis)
        .selectAll('text')
            .filter(function() {
                let keep = this.id != 'x-axis';
                return keep
            })
            .style('text-anchor', 'end')
            .attr('dx', '0em')
            .attr('dy', '-.25em')
            .attr('transform', 'rotate(-45)')
    yAxisG
        .call(yAxis);

    let dataForRegression = comps.map(d=>{
        return {
            x: convertToExcelSerial(d.date),
            y: yValue(d)
        }
    })

    // let lr = percChange(dataForRegression);
    let beginDate = `${taxYear}-01-01`;
    let endDate = `${taxYear}-12-31`;
    // let percDiff =  (
    //     (convertToExcelSerial(endDate)*lr.sl+lr.off )
    //     - (convertToExcelSerial(beginDate)*lr.sl+lr.off)
    //   ) 
    //   / (convertToExcelSerial(beginDate)*lr.sl+lr.off);
    // percDiff = Math.round(percDiff * 100);
    // console.log('percDiff', percDiff);
    // percChangeDiv.innerHTML = `The market trend shows the average sale price per square foot increase by ${percDiff}% during 2021.`


    // console.log('dataForRegression',dataForRegression)

    let xRegressionRange = d3.extent(dataForRegression,d=>d.x);
    // console.log('xRegressionRange', xRegressionRange)
    xRegressionRange[0] = xRegressionRange[0] - xOffset;
    xRegressionRange[1] = xRegressionRange[1] + xOffset;
    const xScaleRegression = d3.scaleLinear()
      .domain(xRegressionRange)
      .range([0, innerWidth])
      // .nice()

    let yRegressionRange = d3.extent(dataForRegression,d=>d.y);
    yRegressionRange[0] = yRegressionRange[0] * (1 - yOffset);
    yRegressionRange[1] = yRegressionRange[1] * (1 + yOffset);
    const yScaleRegression = d3.scaleLinear()
      .domain(yRegressionRange)
      .range([innerHeight, 0])
      // .nice()

    const linearRegression = d3.regressionLinear()
      .x(d => d.x)
      .y(d => d.y);

    const linePolynomial = d3.line()
      .x(d => xScaleRegression(d[0]))
      .y(d => yScaleRegression(d[1]))
    
    const polynomialRegression = d3.regressionPoly()
      .x(d => d.x)
      .y(d => d.y)
      .order(3);

    g.append('line')
      .attr('x1', xScale(new Date(beginDate)))
      .attr('y1', 0)
      .attr('x2', xScale(new Date(beginDate)))
      .attr('y2', innerHeight)
      .style('stroke-width', 2)
      .style('stroke', 'black')
      .style('fill', 'none');

    
    g.append('line')
      .attr('x1', xScale(new Date(endDate)))
      .attr('y1', 0)
      .attr('x2', xScale(new Date(endDate)))
      .attr('y2', innerHeight)
      .style('stroke-width', 2)
      .style('stroke', 'black')
      .style('fill', 'none');
    
    
    g.selectAll('circle')
      .data(comps)
      .enter()
      .append('circle')
          .attr('cx', d => xScale(xValue(d)))
          .attr('cy', d => yScale(yValue(d)))
          .attr('fill', (d)=>{
              let year = new Date(d.date).getFullYear();
              let arr = [taxYear-1,taxYear,taxYear+1];
              let index = arr.indexOf(year);
              return circleColors[index];
          })
          .attr('fill-opacity', circleOpacity)
          .attr('r', 4);
    
    g.append("path")
        .attr("class", "regression")
        .style("stroke-dasharray", ("3, 3"))
        .style('fill', 'none')
        .style('stroke', polyRegressionStroke)
        .style('stroke-width', polyRegressionStrokeWidth)
        .datum(polynomialRegression(dataForRegression))
        .attr("d", linePolynomial);
  }

  function convertToExcelSerial(date){
    let   date1    = new Date('1900-01-01');
    let   date2    = new Date(date);
    const diffTime = Math.abs(date2 - date1);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays;
  }

  function addDays(date, days) {
    const copy = new Date(Number(date))
    copy.setDate(date.getDate() + days)
    return copy
  }

	

  // *************************************************************************
  // Leave this at the bottom - do not put any functions below this section **
  // *************************************************************************
  function initComponents() {
    feather.replace()
    
    //Menu
    // Toggle menu
    $scope.toggleMenu = () => {
        document.getElementById('isToggle').classList.toggle('open')
        var isOpen = document.getElementById('navigation')
        if (isOpen.style.display === "block") {
            isOpen.style.display = "none"
        } else {
            isOpen.style.display = "block"
        }
    }

    //Menu Active
    function getClosest(elem, selector) {

        // Element.matches() polyfill
        if (!Element.prototype.matches) {
            Element.prototype.matches =
                Element.prototype.matchesSelector ||
                Element.prototype.mozMatchesSelector ||
                Element.prototype.msMatchesSelector ||
                Element.prototype.oMatchesSelector ||
                Element.prototype.webkitMatchesSelector ||
                function (s) {
                    var matches = (this.document || this.ownerDocument).querySelectorAll(s),
                        i = matches.length;
                    while (--i >= 0 && matches.item(i) !== this) { }
                    return i > -1;
                };
        }

        // Get the closest matching element
        for (; elem && elem !== document; elem = elem.parentNode) {
            if (elem.matches(selector)) return elem;
        }
        return null;

    };

    function activateMenu() {
        var menuItems = document.getElementsByClassName("sub-menu-item");
        if (menuItems) {

            var matchingMenuItem = null;
            for (var idx = 0; idx < menuItems.length; idx++) {
                if (menuItems[idx].href === window.location.href) {
                    matchingMenuItem = menuItems[idx];
                }
            }

            if (matchingMenuItem) {
                matchingMenuItem.classList.add('active');
                var immediateParent = getClosest(matchingMenuItem, 'li');
                if (immediateParent) {
                    immediateParent.classList.add('active');
                }

                var parent = getClosest(matchingMenuItem, '.parent-menu-item');
                if (parent) {
                    parent.classList.add('active');
                    var parentMenuitem = parent.querySelector('.menu-item');
                    if (parentMenuitem) {
                        parentMenuitem.classList.add('active');
                    }
                    var parentOfParent = getClosest(parent, '.parent-parent-menu-item');
                    if (parentOfParent) {
                        parentOfParent.classList.add('active');
                    }
                } else {
                    var parentOfParent = getClosest(matchingMenuItem, '.parent-parent-menu-item');
                    if (parentOfParent) {
                        parentOfParent.classList.add('active');
                    }
                }
            }
        }
    }

    // Clickable Menu
    if(document.getElementById("navigation")){
      var elements = document.getElementById("navigation").getElementsByTagName("a");
      for(var i = 0, len = elements.length; i < len; i++) {
        elements[i].onclick = function (elem) {
          if(elem.target.getAttribute("href") === "javascript:void(0)") {
            var submenu = elem.target.nextElementSibling.nextElementSibling;
            submenu.classList.toggle('open');
          }
        }
      }
    }

    // Menu sticky
    function windowScroll() {
      const navbar = document.getElementById("topnav");
      if(navbar!=null){
        if (
          document.body.scrollTop >= 50 ||
          document.documentElement.scrollTop >= 50
        ) {
          navbar.classList.add("nav-sticky");
        } else {
          navbar.classList.remove("nav-sticky");
        }
      }
    }

    window.addEventListener('scroll', (ev) => {
        ev.preventDefault();
        windowScroll();
    })

    // back-to-top
    var mybutton = document.getElementById("back-to-top");
    window.onscroll = function () {
        scrollFunction();
    }

    function scrollFunction() {
      if(mybutton!=null){
        if (document.body.scrollTop > 500 || document.documentElement.scrollTop > 500) {
          mybutton.style.display = "block"
        } else {
          mybutton.style.display = "none"
        }
      }
    }

    $scope.topFunction = () => {
      document.body.scrollTop            = 0
      document.documentElement.scrollTop = 0
    }

  }   
 
})